import ShipmentCard from './shipmentCard';

export default ShipmentCard;
